const useListenForNotifications = (): void => {};

export default useListenForNotifications;
